import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromPacks from '../reducers/packs.reducers';
export const selectPacksState = createFeatureSelector<fromPacks.State>('packs');
export const selectPacks = createSelector(
  selectPacksState,
  (state: fromPacks.State) => state.packs
);
export const selectPacksErrorMessage = createSelector(
  selectPacksState,
  (state: fromPacks.State) => state.errorMessage
);
export const selectIsPacksLoading = createSelector(
  selectPacksState,
  (state: fromPacks.State) => state.isLoading
);
